<template>
  <ul
    v-if="images.length > 0"
    class="tile-view"
  >
    <li
      v-for="(image, index) in images"
      :key="index"
    >
      <div class="image-box">
        <img
          v-lazy="image.thumbnailUrl"
          :key="image.thumbnailUrl"
          :class="{ 'hover': hoverIndex === index }"
        />
      </div>
      <div class="info" v-if="mixinIsShowAsync">
        <div v-if="!isLogo" class="id"><span>ID</span>{{ image.code }}</div>
        <div class="name-box">
          <div
            v-if="image.showInput.name"
            key="name"
            class="main-input"
          >
            <input
              type="text"
              v-model="image.filename"
              @keypress.enter="$event.target.blur"
              @blur="$emit('toggleSave', image, 'name', index)"
              :ref="'name' + index"
            />
          </div>
          <div
            v-else
            key="name"
          >
            <span>{{image.filename}}</span>
          </div>
          <button class="pen" v-if="!image.showInput.name" @click="$emit('toggleShowInput', image, 'name', index)"><i class="fas fa-pen"></i></button>
        </div><!-- .nameBox -->
        <div class="alt-box">
          <div
            v-if="image.showInput.alt"
            key="alt"
            class="main-input"
          >
            <input
              type="text"
              :value="image.alt"
              @keypress.enter="$event.target.blur"
              @blur="updateAlt(image, $event.target.value, index)"
              :ref="'alt' + index"
            />
          </div>
          <div
            v-else
            key="alt"
          >
            <span>{{ image.alt }}</span>
          </div>
          <button class="pen" v-if="!image.showInput.alt" @click="$emit('toggleShowInput', image, 'alt', index)"><i class="fas fa-pen"></i></button>
        </div><!-- .altBox -->
        <div class="data">
          <div>
            <span class="info-key">更新者</span><span>：{{ image.modifiedUserName }}</span>
          </div>
          <div>
            <span class="info-key">更新日時</span><span>：{{ image.modifiedOn }}</span>
          </div>
          <div>
            <span class="info-key">サイズ</span><span>：{{ Math.ceil(image.filesize / 1024).toLocaleString() }}KB</span>
          </div>
          <div>
            <span class="info-key">横 × 縦</span><span>：{{ width(image) }}px × {{ height(image) }}px</span>
          </div>
        </div>
      </div><!-- .info -->
      <div
        class="img-nav"
        @mouseover="hoverIndex = index"
        @mouseleave="hoverIndex = null"
      >
        <div
          v-if="!isLogo && image.showInput && !isCallByEditor"
          class="checkbox"
          :class="{ 'hover' : hoverIndex === index }"
          v-show="image.checked || (hoverIndex === index)"
        >
          <input
            type="checkbox"
            :name="index"
            :id="index"
            v-model="image.checked"
          />
          <label :for="index"></label>
        </div>
        <ul class="nav-list" :class="{ 'hover': hoverIndex === index }">
          <template v-if="isCallByEditor">
            <li class="preview" @click="$emit('showImagePreview', image)">プレビュー</li>
            <li class="select" @click="$emit('selectImage', image, image)">選択</li>
          </template>
          <template v-else>
            <li class="preview" @click="$emit('showImagePreview', image)">プレビュー</li>
            <li class="edit" @click="$emit('showImageDetailEditor', image)">編集</li>
            <li class="delete" @click="$emit('deleteConfirm', image)">削除</li>
          </template>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import AsyncShowBase from '@/mixins/AsyncShowBase'

export default {
  props: [
    'images',
    'isCallByEditor',
    'isLogo',
  ],
  mixins: [
    AsyncShowBase
  ],
  data () {
    return {
      hoverIndex: null,
    }
  },
  computed: {
    width () {
      return function (image) {
        return Number(image.width.replace('px', '')).toLocaleString()
      }
    },
    height () {
      return function (image) {
        return Number(image.height.replace('px', '')).toLocaleString()
      }
    }
  },
  mounted () {
    this.mixinAsyncShow('images')
  },
  methods: {
    onInputEnter (event) {
      event.key === 'Enter' && event.target.blur()
    },
    updateAlt (image, value, index) {
      image.alt = value
      this.$emit('toggleSave', image, 'alt', index)
    },
  }
}
</script>

<style lang="scss" scoped>
.tile-view {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  > li {
    height: 400px;
    width: 250px;
    padding: 8px 8px 20px 8px;
    position: relative;
    &:hover {
      background: rgba($primaryHoverColor, 0.1);
      border-radius: 2px;
    }
  }
}
.image-box {
  margin: 0 auto 10px;
  border: .5px solid #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  display: block;
  width: 230px;
  height: 230px;
  img {
    opacity: 0;
    width: 230px;
    height: 230px;
    object-fit: contain;
    background: #e4e4e4;
    transition: all 0.3s ease 0s;
    &.hover {
      filter: brightness(50%) blur(3px);
      transition: all 0.3s ease 0s;
    }
  }
  img[lazy=loaded] {
    opacity: 1;
  }
}
.info {
  padding: 0 10px 10px 10px;
  box-sizing: border-box;
  .pen {
    background: inherit;
    cursor: pointer;
    user-select: none;
    padding-left: 3px;
  }
  .id {
    font-size: 12px;
    color: rgba(#484848, 0.6);
    span {
      display: inline-block;
      text-align: center;
      border-radius: 12px;
      background: #e4e4e4;
      width: 30px;
      height: 19px;
      margin-right: 8px;
    }
  }
  .name-box {
    display: flex;
    flex: 1;
    > div {
      overflow: hidden;
    }
    .main-input {
      margin-top: 0;
    }
    span {
      font-size: 16px;
      color: rgba($baseFontColor, 0.9);
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      display: block;
    }
    .pen {
      padding: 0 0 3px 3px;
    }
  }
  .alt-box {
    display: flex;
    flex: 1;
    margin-top: 5px;
    > div {
      overflow: hidden;
    }
    span {
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      display: block;
      &::before {
        content: 'alt';
        display: inline-block;
        text-align: center;
        width: 34px;
        height: 24px;
        border-radius: 12px;
        margin-right: 5px;
        background: #e4e4e4;
      }
    }
  }
  input {
    width: 210px;
    background: #e4e4e4;
    padding: 0 5px;
    border-radius: 2px;
  }
  button {
    display: inline;
  }
  .data {
    margin-top: 5px;
    .info-key {
      display: inline-block;
      width: 57px;
    }
  }
}
// 画像ホバー時のメニュー
.img-nav {
  position: absolute;
  width: 230px;
  height: 230px;
  top: 10px;
  left: 20px;
  .nav-list {
    position: absolute;
    top: 50%;
    left: 47%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease 0s;
    display: none;
    &.hover {
      display: block;
      transition: all 0.3s ease 0s;
    }
    li {
      white-space: nowrap;
      font-weight: 300;
      padding: 0 10px;
      border-radius: 2px;
      transition: all 0.3s ease 0s;
      color:#fff;
      display: block;
      width: 100%;
      cursor: pointer;
      margin: 15px auto;
      &:hover, &:active {
        color: #bbbbbb;
        transition: all 0.3s ease 0s;
      }
      &::before {
        font-family: "Font Awesome 5 Free";
      }
      &.preview::before {
        content: '\f06e';
        font-weight: 900;
        padding-right: 8px;
      }
      &.edit::before {
        content: '\f044';
        font-weight: 900;
        padding-right: 9px;
      }
      &.delete::before {
        content: '\f2ed';
        padding-right: 12px;
      }
      &.select::before {
        content: '\f14a';
        font-weight: 900;
        padding-right: 12px;
      }
    }
  }
  // 一括操作のチェックボックス
  .checkbox {
    position: absolute;
    top:10px;
    left: 10px;
    &.hover {
      display: block;
      transition: all 0.3s ease 0s;
    }
    input[type=checkbox] {
      display:  none;
      + label {
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        box-sizing: border-box;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
      }
    }
  }
}
</style>
